import type { ComponentPropsWithoutRef } from 'react';
import DateTimeInput from '../../../../../../../generic/DateTimeInput';
import ValuePickerWrapper from './ValuePickerWrapper';

interface DateTimeInputWithValuePickerProps
    extends ComponentPropsWithoutRef<typeof ValuePickerWrapper> {
    isUTC?: boolean;
}

const DateTimeInputWithValuePicker = ({
    id,
    label,
    isRequired = false,
    testId,
    value,
    isUTC = false,
    container,
    description,
    onChangeAsValueReference,
}: DateTimeInputWithValuePickerProps) => {
    return (
        <ValuePickerWrapper
            container={container}
            id={id}
            label={label}
            onChangeAsValueReference={onChangeAsValueReference}
            testId={testId}
            value={value}
            description={description}
            isRequired={isRequired}
            contentType="ContentDateTime"
        >
            <DateTimeInput
                className="form-control"
                value={typeof value === 'string' || typeof value === 'number' ? String(value) : ''}
                onChange={(dateValue) => {
                    onChangeAsValueReference(dateValue);
                }}
                isUTC={isUTC}
            />
        </ValuePickerWrapper>
    );
};

export default DateTimeInputWithValuePicker;
